import { IMatch } from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';

export function getBracketCellSlotLabel(
  team: { name?: string } | null | undefined,
  placeholder: string | null | undefined,
): string | null {
  if (team?.name) {
    return team.name;
  }
  if (placeholder) {
    return placeholder;
  }
  return null;
}

export function getBracketCellMatchupLabel(
  match: Pick<IMatch, 'homeTeam' | 'awayTeam' | 'homeTeamPlaceholder' | 'awayTeamPlaceholder'>,
): string | null {
  const home = getBracketCellSlotLabel(match.homeTeam, match.homeTeamPlaceholder);
  const away = getBracketCellSlotLabel(match.awayTeam, match.awayTeamPlaceholder);
  if (!home && !away) {
    return null;
  }
  return `${home ?? 'TBD'} vs ${away ?? 'TBD'}`;
}

export function getBracketCellHeaderSuffix(
  match: Pick<IMatch, 'matchId' | 'type'>,
  variant: 'group' | 'elimination',
): string | null {
  if (variant === 'group' && match.type != null) {
    return `round:${match.type}`;
  }
  if (variant === 'elimination' && /^M\d+-E-/.test(match.matchId ?? '')) {
    return match.matchId;
  }
  return null;
}
